import HelpingCompaniesComponent from 'components/marketingSite/helpingCompanies/HelpingCompaniesComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/dist/client/router';
import { useEffect, useState } from 'react';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type HelpingCompaniesPageProps = {
  baseUrl?: string;
};

const parseJSON = (resp: any) => (resp.json ? resp.json() : resp);

const checkStatus = (resp: any) => {
  if (resp.status >= 200 && resp.status < 300) {
    return resp;
  }

  return parseJSON(resp).then((resp: any) => {
    throw resp;
  });
};

const headers = { 'Content-Type': 'application/json' };

const HelpingCompanies: React.FC<HelpingCompaniesPageProps> = ({ baseUrl }) => {
  const { t } = useI18n('helping-companies');

  usePageTrack('Landing - Page Loaded');

  const { locale } = useRouter();

  const [helpingCompanies, setHelpingCompanies] = useState([]);
  const [helpingCompaniesLinks, setHelpingCompaniesLinks] = useState([]);

  useEffect(() => {
    fetch(
      `https://cms.getmanfred.com/api/helping-co-sections?populate=%2A&pagination[pageSize]=100&locale=${locale}`,
      {
        headers,
        method: 'GET'
      }
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data }) => setHelpingCompanies(data));
  }, []);

  useEffect(() => {
    fetch(
      `https://cms.getmanfred.com/api/helping-co-section-links?populate=%2A&pagination[pageSize]=100&locale=${locale}`,
      {
        headers,
        method: 'GET'
      }
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data }) => setHelpingCompaniesLinks(data));
  }, []);

  return (
    <>
      <HeadMetadata
        title={t('helping-companies.page_title')}
        url={APP_URLS.helpingCompanies}
        desc={t('helping-companies.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_helping_companies.png'
        )}`}
      />
      <HelpingCompaniesComponent
        content={helpingCompanies}
        links={helpingCompaniesLinks}
      />
    </>
  );
};

export default HelpingCompanies;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'helping-companies'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
